import React from 'react';
import { View } from 'react-native-web';
import Title from '../Text/Title';
import RadiusContainer from './RadiusContainer';
import RegularText from '../Text/RegularText';

//= ========================================================================

const RadiusMenu = ({
  globJSON,
  onConfigChanged,
  headline,
  paragraph,
  list,
}) => (
  <View>
    <Title>{headline}</Title>
    <RegularText>{paragraph}</RegularText>
    <View style={{
      flexDirection: 'row',
      flexWrap: 'wrap',
    }}
    >
      {list.map((listParams) => <RadiusContainer globJSON={globJSON} onConfigChanged={onConfigChanged} object={listParams} />)}
    </View>
  </View>

);
export default RadiusMenu;
